import { gql } from '@apollo/client';

export const queryName = 'dateOfBirth';
export const dateOfBirthName = 'DateOfBirth';
export const dateOfBirth = gql`
	fragment ${dateOfBirthName} on Member {
		dateOfBirth
	}
`;
